module.exports = "<div class=nn-addon-brightcove><div brightcove-new video-test=bysxz-new video-id=\"{{ brightcoveSettings.src }}\" data-video-vtt={{brightcoveSettings.item.metaData.subTitles}} video-poster=\"{{ brightcoveSettings.item.metaData.videoStillURL }}\"></div></div>"


//////////////////
// WEBPACK FOOTER
// ./app/components/nn-add-ons/nn-addon-brightcove/nn-addon-brightcove.directive.html
// module id = 942
// module chunks = 0